var map = {
	"./accepted_dark.svg": "3a8b",
	"./accepted_light.svg": "6109",
	"./checking_on_dark.svg": "45b1",
	"./checking_on_light.svg": "e8af",
	"./closed_dark.svg": "59dc",
	"./closed_light.svg": "7112",
	"./done_dark.svg": "4551",
	"./done_light.svg": "9279",
	"./initial_dark.svg": "84eb",
	"./initial_light.svg": "0a1d",
	"./issues_count_dark.svg": "3f07",
	"./issues_count_light.svg": "6d5f",
	"./new_dark.svg": "50db",
	"./new_light.svg": "e649",
	"./overdue_dark.svg": "9acd",
	"./overdue_light.svg": "aeac",
	"./paused_dark.svg": "dbac",
	"./paused_light.svg": "81ef",
	"./pre_overdue_dark.svg": "a179",
	"./pre_overdue_light.svg": "64d6",
	"./processing_dark.svg": "38f8",
	"./processing_light.svg": "67cd",
	"./rejected_dark.svg": "b742",
	"./rejected_light.svg": "e391",
	"./reworked_dark.svg": "0a25",
	"./reworked_light.svg": "54cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "958bd";